import Upload from './Upload';
import Dragger from './Dragger';
Upload.Dragger = Dragger;
export default Upload;


//////////////////
// WEBPACK FOOTER
// ./node_modules/.3.6.1@antd/es/upload/index.js
// module id = 997
// module chunks = 1